import { Button, LoadingSpinner } from "@jugl-web/ui-components";
import { cx, useTranslations } from "@jugl-web/utils";

import { useInvoicesSettingsPageContext } from "../../../../context/useInvoicesSettingsPageContext";

export const InvoiceSettingsFooterButtons = () => {
  const { t } = useTranslations();
  const { submitForm, isSaving } = useInvoicesSettingsPageContext();

  return (
    <div className="flex shrink-0 items-center justify-end gap-4 border-0 border-t-2  border-solid border-[#EEF2F5] bg-white px-[70px] py-5">
      <Button
        onClick={submitForm}
        isDisabled={isSaving}
        className="relative"
        size="small"
      >
        {isSaving ? <LoadingSpinner size="xs" className="absolute" /> : null}

        <span
          className={cx({
            "opacity-0": isSaving,
          })}
        >
          {t({
            id: "common.save",
            defaultMessage: "Save",
          })}
        </span>
      </Button>
    </div>
  );
};
